import type { MutableRefObject } from 'react';

import Header from '../landing-pages-v2/shared/header/Header';
import type { MegaNavItem, MenuLink } from '../landing-pages-v2/shared/types';

const mainNavLinks: MenuLink[] = [
  {
    name: 'Sell',
    href: '/how-it-works-sell',
  },
  {
    name: 'Buy',
    href: '/homes',
  },
  {
    name: 'Agents',
    href: '/agents',
  },
];

const menuPanelNavLinks: MenuLink[] = [];

const megaNavData: MegaNavItem[] = [
  {
    name: 'Sell',
    href: '/how-it-works-sell',
    sections: [
      {
        title: 'Ways to Sell',
        links: [
          { name: 'All Cash Offer', href: '/how-it-works-sell' },
          { name: 'Cash Now More Later', href: '/cash-now-more-later' },
        ],
      },
      {
        title: 'Home Selling Resources',
        links: [
          {
            name: 'Sell my home for cash',
            href: '/articles/sell-your-house-for-fast-cash-with-Opendoor',
          },
          {
            name: 'How to Sell Your House',
            href: '/articles/how-to-sell-your-house-fast-complete-guide',
          },
          { name: 'Hidden Selling Fees', href: '/articles/hidden-fees-when-selling-a-house' },
          {
            name: 'Why Homes Don’t Sell',
            href: '/articles/cant-sell-my-house-why-its-happening-and-how-to-fix-it',
          },
          {
            name: 'How To Determine Your Home’s Value',
            href: '/articles/factors-that-influence-home-value',
          },
        ],
      },
      {
        title: 'Tools',
        links: [
          { name: 'Get my cash offer', href: '/address-entry' },
          { name: 'Home Value Estimator', href: '/home-value-estimator' },
          { name: 'Home Sale Calculator', href: '/home-sale-calculator' },
          { name: 'Browse All', href: '/articles/topic/sell' },
        ],
      },
      {
        title: 'Your Situation',
        links: [
          { name: 'Relocating for work', href: '/relocation' },
          { name: 'Divorce or separation', href: '/divorce' },
          { name: 'Military or PCS move', href: '/military' },
        ],
      },
    ],
  },
  {
    name: 'Buy',
    href: '/homes',
    sections: [
      {
        title: 'Homes for sale',
        links: [
          { name: 'For sale in Atlanta', href: '/homes/atlanta' },
          { name: 'For sale in Dallas', href: '/homes/dallas' },
          { name: 'For sale in Charlotte', href: '/homes/charlotte' },
          { name: 'Browse all', href: '/homes' },
          { name: 'Buy from Opendoor', href: '/how-it-works-buy' },
        ],
      },
      {
        title: 'Homebuying',
        links: [
          { name: 'How to buy a house', href: '/articles/how-to-buy-a-house' },
          { name: 'Buy at the right time', href: '/articles/best-time-of-year-to-buy-a-house' },
          {
            name: 'Buy at the right price',
            href: '/articles/how-much-does-it-cost-to-buy-a-house',
          },
          { name: 'Browse All', href: '/articles/topic/buy' },
        ],
      },
      {
        title: 'Tools',
        links: [{ name: 'Mortgage calculator', href: '/mortgage-calculator' }],
      },
    ],
  },
  {
    name: 'Agents',
    href: '/agents',
  },
];

interface StaticSiteHeaderProps {
  slug: string;
  closeMenuRef?: MutableRefObject<() => void>;
  className?: string;
}

const ctaLink: MenuLink = {
  name: 'Get a cash offer',
  href: '/',
};

const StaticSiteHeader = ({ slug, closeMenuRef, className }: StaticSiteHeaderProps) => {
  return (
    <Header
      menuPanelNavLinks={menuPanelNavLinks}
      mainNavLinks={mainNavLinks}
      ctaTitle="Get started"
      ctaLink={ctaLink}
      slug={slug}
      megaNavData={megaNavData}
      closeMenuRef={closeMenuRef}
      className={className}
    />
  );
};

export default StaticSiteHeader;
